import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback } from 'react';
import { useField } from '../hooks/use-field';
import { useFieldAuthor } from '../hooks/use-field-author';
export const connectField = (Component, options) => {
    const MyComp = ({ id, name, idStrategy = 'auto', relatedName, tunes, isDisabled, ...rest }) => {
        const field = useField(name, options.fieldType);
        const lastAuthor = useFieldAuthor({
            pageId: field.jaenPageId,
            section: field.SectionBlockContext
                ? {
                    path: field.SectionBlockContext.path,
                    id: field.SectionBlockContext.id
                }
                : undefined,
            fieldType: options.fieldType,
            fieldName: name
        });
        if (!id) {
            if (idStrategy === 'auto') {
                id = name;
                if (field.SectionBlockContext) {
                    const { path, position } = field.SectionBlockContext;
                    const fqn = path
                        .map(p => p.sectionId ? `${p.fieldName}-${p.sectionId}` : p.fieldName)
                        .join('-');
                    id = `${fqn}-${position}-${name}`;
                }
            }
            else if (idStrategy === 'value') {
                const value = field.value || field.staticValue;
                if (value && typeof value === 'string') {
                    id = `${value
                        .replace(/(<([^>]+)>)/gi, '')
                        .replace(/[^a-zA-Z0-9 ]/g, '')
                        .replace(/\s+/g, '-')
                        .toLowerCase()}`;
                }
            }
            if (!id) {
                id = name;
            }
        }
        const register = useCallback((newProps) => {
            field.register({
                id,
                relatedName,
                ...field.props,
                ...newProps
            });
        }, [id, relatedName, field.props]);
        const tune = useCallback(info => {
            let activeTunes = field.props?.activeTunes || [];
            activeTunes = activeTunes.filter(activeTune => activeTune.name !== info.name &&
                activeTune.groupName !== info.groupName);
            if (!info.isActive) {
                activeTunes.push({
                    name: info.name,
                    groupName: info.groupName
                });
            }
            register({
                activeTunes: activeTunes.length > 0 ? activeTunes : undefined
            });
        }, [field.props?.activeTunes, register]);
        return (_jsx(Component, { jaenField: {
                id,
                idStrategy,
                name,
                staticValue: field.staticValue,
                value: field.value,
                isEditing: field.isEditing && !isDisabled,
                onUpdateValue: field.write,
                register,
                tune,
                style: rest.style,
                className: rest.className,
                relatedName,
                tunes: tunes || [],
                activeTunes: field.props?.activeTunes,
                isDisabled,
                lastAuthor
            }, ...rest }));
    };
    MyComp.options = options;
    return React.memo(MyComp);
};
